import { CSSProperties, useEffect, useRef } from "react";
import { Button } from "@mui/material";
import DOMPurify from 'dompurify';

import { classNames } from "~/utils/utils";
import { myUseState } from "~/hooks/myUseState";
import { useTrans } from "~/hooks/useTrans";

import "./style.less";

interface IState {
	hasOverflow: boolean;
	showMore: boolean;
}

interface IWysiwygDisplay {
	html: string;
	className?: string;
	maxHeight?: number;
}

export default function WysiwygDisplay({
	html,
	className = "",
	maxHeight = 0,
}: IWysiwygDisplay) {
	const htmlRef = useRef<HTMLDivElement>(null);
	const { trans } = useTrans();
	const { state, updateState, toggleState } = myUseState<IState>({
		hasOverflow: false,
		showMore: false,
	});
	const contentStyle: CSSProperties = {
		...maxHeight > 0
			? {
				maxHeight: `${maxHeight}px`,
				overflow: "hidden",
			}
			: {},
	};

	useEffect(() => {
		if (maxHeight > 0 && htmlRef.current) {
			const height = htmlRef.current.scrollHeight;

			if (height > maxHeight) {
				updateState({
					hasOverflow: true,
				});
			}
		}
	}, [htmlRef]);

	return <div className="wysiwygDisplay">
		<div className={classNames(["wysiwygDisplay__content", state.showMore ? "show-more" : "", className])} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} ref={htmlRef} style={contentStyle} />
		{ state.hasOverflow && <div className="wysiwygDisplay__showMoreArea">
			<Button onClick={() => toggleState("showMore")} variant="outlined">
				{ state.showMore ? trans("jsonViewer.hide") : trans("jsonViewer.showMore") }
			</Button>
		</div> }
	</div>;
}
